// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditableTelekino_container__bnDg\\+ {
  animation: EditableTelekino_init__DTF-U 1s;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_header__5X3kx {
  animation: EditableTelekino_init__DTF-U 1.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_header__5X3kx .EditableTelekino_arrow__GAU\\+L {
  transition: 0.3s;
  border-radius: 100%;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_header__5X3kx .EditableTelekino_arrow__GAU\\+L:hover {
  transition: 0.3s;
  scale: 1.1;
  filter: brightness(1.2);
  background-color: rgba(128, 128, 128, 0.15);
  cursor: pointer;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_header__5X3kx .EditableTelekino_titleContainer__3azDm {
  display: flex;
  justify-content: center;
  align-items: center;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_header__5X3kx .EditableTelekino_titleContainer__3azDm h4 {
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_confirmHeaderData__1SVFt {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_confirmHeaderData__1SVFt .EditableTelekino_data__IhVgI span {
  font-size: 1.3rem;
  border-bottom: 1px solid grey;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_confirmHeaderData__1SVFt .EditableTelekino_data__IhVgI p {
  font-size: 1.1rem;
  margin-top: 10px;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_couponsSearch__eX35X {
  margin-bottom: 20px;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_couponsSearch__eX35X p {
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 600;
}

/*---Información---*/
.EditableTelekino_container__bnDg\\+ .EditableTelekino_tableContainer__RyBdl {
  animation: EditableTelekino_init__DTF-U 1.3s;
  border-radius: 5px;
  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);
  margin-bottom: 50px;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_agencySelector__mw4a- {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100px;
  margin-bottom: 30px;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_agencySelector__mw4a- .EditableTelekino_agencyItem__rTMut {
  padding-inline: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  height: 50px;
  margin-left: 20px;
  border: 1px solid lightgrey;
  border-radius: 5px;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_agencySelector__mw4a- .EditableTelekino_agencyItem__rTMut p {
  font-size: 2rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.EditableTelekino_container__bnDg\\+ .EditableTelekino_btn__hvR-I {
  width: 230px;
  height: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/PanelDistribucionTelekino/Editable/EditableTelekino.module.css"],"names":[],"mappings":"AAAA;EACE,0CAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4CAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,4CAAoB;EACpB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":[".container {\n  animation: init 1s;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n}\n\n.container .header {\n  animation: init 1.3s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .arrow {\n  transition: 0.3s;\n  border-radius: 100%;\n}\n\n.container .header .arrow:hover {\n  transition: 0.3s;\n  scale: 1.1;\n  filter: brightness(1.2);\n  background-color: rgba(128, 128, 128, 0.15);\n  cursor: pointer;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .confirmHeaderData {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .confirmHeaderData .data span {\n  font-size: 1.3rem;\n  border-bottom: 1px solid grey;\n}\n\n.container .confirmHeaderData .data p {\n  font-size: 1.1rem;\n  margin-top: 10px;\n}\n\n.container .couponsSearch {\n  margin-bottom: 20px;\n}\n\n.container .couponsSearch p {\n  margin: 0 0 10px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/*---Información---*/\n.container .tableContainer {\n  animation: init 1.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);\n  margin-bottom: 50px;\n}\n\n.container .agencySelector {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100px;\n  margin-bottom: 30px;\n}\n\n.container .agencySelector .agencyItem {\n  padding-inline: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  height: 50px;\n  margin-left: 20px;\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n}\n\n.container .agencySelector .agencyItem p {\n  font-size: 2rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .btn {\n  width: 230px;\n  height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EditableTelekino_container__bnDg+`,
	"init": `EditableTelekino_init__DTF-U`,
	"header": `EditableTelekino_header__5X3kx`,
	"arrow": `EditableTelekino_arrow__GAU+L`,
	"titleContainer": `EditableTelekino_titleContainer__3azDm`,
	"confirmHeaderData": `EditableTelekino_confirmHeaderData__1SVFt`,
	"data": `EditableTelekino_data__IhVgI`,
	"couponsSearch": `EditableTelekino_couponsSearch__eX35X`,
	"tableContainer": `EditableTelekino_tableContainer__RyBdl`,
	"agencySelector": `EditableTelekino_agencySelector__mw4a-`,
	"agencyItem": `EditableTelekino_agencyItem__rTMut`,
	"btn": `EditableTelekino_btn__hvR-I`
};
export default ___CSS_LOADER_EXPORT___;
